export default ({index, isFilled, isHalfFilled, label, rid}) => `
    <input id='star${index}-${rid}' class='starRadio' type='radio' value='${index}' aria-label='${label}' name='${rid}'/>
    <span for='star${index}-${rid}'><i data-index='${index}' class='icon icon-star contrast StarRatings-star ${isHalfFilled ? 'halfFilled' : ''} ${!!isFilled ? 'filled' : ''}'></i></span>
`;
